// Follow the same pattern as other endpoint files: export a function that
// accepts the RTK Query `builder` and returns an object of endpoint defs.
// This file must NOT import `baseApi` (that creates a circular import when
// `baseApi` imports the endpoints index). The hooks are generated from
// `baseApi.createApi(...)` so we only export the endpoint factory here.

export const riderEndpoints = (builder) => ({
  getAvailableRiders: builder.query({
    query: (payload = {}) => {
      // Accept either camelCase or PascalCase keys from callers
      const insurerId = payload?.InsurerID ?? payload?.insurerId ?? payload?.InsurerId ?? null;
      // const productId = payload?.ProductID ?? payload?.productId ?? payload?.ProductId ?? null;

      return {
        url: '/rider/available-riders',
        method: 'GET',
        // Backend expects InsurerID and ProductID as query params
        params: { InsurerID: insurerId},
      };
    },
    providesTags: (result) => {
      // API returns { success, message, data }
      const rows = result && Array.isArray(result.data) ? result.data : [];
      return rows.length > 0
        ? [
            ...rows.map(({ RiderId }) => ({ type: 'Rider', id: RiderId })),
            { type: 'Rider', id: 'LIST' },
          ]
        : [{ type: 'Rider', id: 'LIST' }];
    },
  }),
});

